import { SEO } from '../components/SEO';
import { PageHero } from '../components/PageHero';
import { ScrollReveal } from '../components/ScrollReveal';
import { DarkTexture } from '../components/DarkTexture';
import { caseLaws, enforcementWatchNote } from '../data/caseLaws';

const justiceImg = 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?q=80&w=1200';

const CaseLaws = () => (
  <div className="bg-navy">
    <SEO
      title="DPDPA Case Laws — Puttaswamy, Aadhaar Judgment & Privacy Precedent"
      description="The constitutional and judicial history behind India's DPDPA — K.S. Puttaswamy right to privacy judgment, the Aadhaar case, and other landmark privacy precedent."
      path="/case-laws"
    />
    <PageHero
      testId="case-laws-page-hero"
      kicker="Precedent & Context"
      title="Case Laws"
      description="The constitutional and judicial history behind India's data protection law — from the right to privacy to the DPDPA's earliest enforcement chapter."
    />

    <section className="bg-navy py-4">
      <div
        className="relative h-56 sm:h-72 w-full overflow-hidden max-w-6xl mx-auto"
        style={{ clipPath: 'polygon(0 0, 100% 0, 100% 92%, 97% 100%, 0 100%)' }}
      >
        <img src={justiceImg} alt="Scales of justice" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-navy/40" />
      </div>
    </section>

    <section className="relative bg-navy py-16 sm:py-24 px-6 sm:px-10 lg:px-16 overflow-hidden" data-testid="case-laws-list-section">
      <DarkTexture orbs={false} />
      <div className="relative max-w-4xl mx-auto space-y-8">
        {caseLaws.map((c) => (
          <ScrollReveal key={c.id}>
            <div data-testid={`case-law-card-${c.id}`} className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:border-cyan/30 transition-colors duration-300">
              <p className="font-mono text-xs uppercase tracking-widest text-cyan mb-3">{c.tag} · {c.year}</p>
              <h2 className="font-serif text-2xl text-white mb-2">{c.title}</h2>
              <p className="text-xs text-white/30 mb-4">{c.citation}</p>
              <p className="text-white/60 leading-relaxed mb-4">{c.summary}</p>
              <p className="text-sm text-white/70 border-t border-white/10 pt-4"><span className="font-medium text-white">Relevance to DPDPA: </span>{c.relevance}</p>
            </div>
          </ScrollReveal>
        ))}
        <ScrollReveal>
          <div className="bg-white/5 text-white/60 text-sm leading-relaxed p-6 border-l-2 border-cyan rounded-r-xl">{enforcementWatchNote}</div>
        </ScrollReveal>
      </div>
    </section>
  </div>
);

export default CaseLaws;
